import Vue from 'vue'
import Vuex from 'vuex' 
Vue.use(Vuex)
import { getloginPass, getloginCode,getQiyes,getUserInfo,getAllNotice} from '@/api/api'
import { getToken, setToken, removeToken } from '@/request/auth'
import { Notification, MessageBox, Message } from 'element-ui'
import Cookies from "js-cookie"
export default new Vuex.Store ({
  state: {
    token: getToken(),
    userinfo:'',//用户信息
    memberId:'11'
  },  
  mutations: {
    SET_TOKEN: (state, token) => {
      state.token = token
    },
    SET_USER_INFO: (state, userinfo) => {      
      state.userinfo = userinfo      
    }
  }, 
  actions: {
     // 验证码登录
     loginCode({ commit }, userInfo) {    
      return new Promise((resolve, reject) => {    
        getloginCode(userInfo).then(res => {    
          
          if(res.body.result.COID){
            setToken(res.body.result.token)
            commit('SET_TOKEN', res.body.result.token)
            commit('SET_USER_INFO', res.body.result)        
            Cookies.set('qsluserId',res.body.result.userId)  
            Cookies.set('qslCOID',res.body.result.COID) 
            Cookies.set('qslCONAME',res.body.result.companyName)  
            Cookies.set('qslCOLOGO','@/assets/logo.png') 
            Cookies.set('qslmemberId',res.body.result.memberId)           
            resolve(res)
            
          }
          else{
            MessageBox.confirm('您不在任何企业，请加入企业再登录！', '系统提示', {
              cancelButtonText: '确定',
              type: 'warning'
            })
            reject()
          }          
        }).catch(error => {
          console.log(error)
          reject(error)
        })
      })
    },
    // 密码登录
    loginPass({ commit }, userInfo) {          
      return new Promise((resolve, reject) => {   
        getloginPass(userInfo).then(res => { 
          
          if(res.body.result.COID){
            setToken(res.body.result.token)
            commit('SET_TOKEN', res.body.result.token)
            commit('SET_USER_INFO', res.body.result)         
            Cookies.set('qsluserId',res.body.result.userId)  
            Cookies.set('qslCOID',res.body.result.COID)   
            Cookies.set('qslCONAME',res.body.result.companyName)           
            Cookies.set('qslmemberId',res.body.result.memberId)                
            resolve(res)
          }   
          else{
            MessageBox.confirm('您不在任何企业，请加入企业再登录！', '系统提示', {
              cancelButtonText: '确定',
              type: 'warning'
            })
            reject()
          }          
        }).catch(error => {
          console.log(error)
          reject(error)
        })
      })
    },     
    // 获取企业大学
    GetComp({ commit, state }) {      
      var data = {
				userId: Cookies.get('qsluserId')        
			}    
      return new Promise((resolve, reject) => {
        getQiyes(data).then(res => {            
          resolve(res)              
        }).catch(error => {
          console.log(error)
          reject(error)
        })
      })
    },
    // 获取公告
    getNoticeList({ commit, state },pageSize) {   
      console.log(pageSize)   
      var data = {
          COID : Cookies.get('qslCOID'),          
          memberId: Cookies.get('qslmemberId'),
          pageIndex:1,
          pageSize:pageSize			  
      }      
      return new Promise((resolve, reject) => {
        getAllNotice(data).then(res => {            
          resolve(res)              
        }).catch(error => {
          console.log(error)
          reject(error)
        })
      })
    },
    // 获取用户信息
    GetInfo({ commit, state }) {
      return new Promise((resolve, reject) => {       
        var data = {
          token : getToken(),          
          userId: Cookies.get('qsluserId'),
			  	COID: Cookies.get('qslCOID')
        }                   
        getUserInfo(data).then(res => { 
          Cookies.set('qslUserInfo',JSON.stringify(res.body.result))  //用户信息接口返回             
          //const avatar = user.avatar == "" ? require("@/assets/images/profile.jpg") : process.env.VUE_APP_BASE_API + user.avatar;       
          resolve(res)
        }).catch(error => {
          reject(error)
        })
      })
    },  
    // 前端登出
    LogOut({ commit }) {
      const clearCookie = () => {
        var keys = document.cookie.match(/[^ =;]+(?==)/g);
        if (keys) {
          for (var i = keys.length; i--; ) {
            document.cookie =
              keys[i] +
              "=0;expires=" +
              new Date(0).toUTCString() +
              ";max-age=0";
          }
        }
      };
      return new Promise(resolve => {
        commit('SET_TOKEN', '')
        sessionStorage.removeItem("qslHelpList");
        sessionStorage.removeItem("qslCompList");
        sessionStorage.clear();
        clearCookie(); 
        removeToken()
        resolve()
      })
    }
  }
})





// WEBPACK FOOTER //
// ./src/store/index.js